import {
  BUSINESS_TYPE,
  ACCESS_TOKEN,
  BANK_ID,
  BRAND_ID,
  CASE_ID,
  REDIRECT_URI,
  CASE_SUBTYPE,
  CUSTOMER_UUID,
  INITIAL_QUESTIONS_TMSP,
  NAVIGATE_TO_CD_REVIEW,
  LINK_CODE_KEY,
  PRODUCT_NAME,
  APPLICANT_FLOW,
  LINK_CODE_RESUME_FLOW
} from './constants';
import {
  BD_REVIEW,
  getBDDScreensByBusinessType
} from '../store/middleware/redirectActionMiddleware';

/**
 * To redirect to personal details application
 * @param {string} access_token
 * @param {string} bank_id
 * @param {string} brand_id
 * @param {string} customer_uuid
 * @param {string} page
 * @param {string} caseID
 * @param {string} offer
 * @param {string} timestamp
 * @param {string} caseSubType
 */

export const redirectOnExit = (bank_id = 'cb') => {
  const href = `https://uk.virginmoney.com/business`;
  window.location.href = href;
};

export function redirectToPersonalDetails(
  customerUrl,
  access_token,
  bank_id,
  brand_id,
  show,
  businessType,
  customer_uuid,
  page,
  offer,
  caseSubType,
  timestamp,
  case_id,
  navigatePage,
  navigation,
  sourceId,
  linkCode,
  primaryApplicantFlow,
  linkCodeResume
) {
  let navigate = customerUrl;
  navigate = navigate.replace(window.location.hash, '');
  const offer_type = offer ? `${PRODUCT_NAME}=${offer}` : '';
  const init_timestamp = timestamp ? `${INITIAL_QUESTIONS_TMSP}=${timestamp}` : '';
  const caseID = case_id ? `${CASE_ID}=${case_id}` : '';
  const token = access_token ? `${ACCESS_TOKEN}=${access_token}&` : '';
  const bankId = bank_id ? `&${BANK_ID}=${bank_id}` : '';
  const sourceid = sourceId ? `&sourceId=${sourceId}` : '';
  const linke_code = linkCode ? `&${LINK_CODE_KEY}=${linkCode}` : '';
  const appFlow = primaryApplicantFlow ? `&${APPLICANT_FLOW}=${primaryApplicantFlow}` : '';
  const linkResume = linkCodeResume ? `&${LINK_CODE_RESUME_FLOW}=${linkCodeResume}` : '';
  const nav = navigation ? `&navigation=${navigation}` : '';
  const cust_id = customer_uuid ? `&${CUSTOMER_UUID}=${customer_uuid}` : '';
  const layout =
    navigatePage === NAVIGATE_TO_CD_REVIEW ? `&show=${show}` : `&layout=page&show=${show}`;
  const redirect_uri = encodeURIComponent(
    `${window.location.href.replace(
      window.location.hash,
      ''
    )}#${token}${CUSTOMER_UUID}=${customer_uuid || ''}&${page.replace(
      '/',
      ''
    )}&${BUSINESS_TYPE}=${businessType}&${offer_type}&${caseID}&${init_timestamp}&${CASE_SUBTYPE}=${caseSubType}${bankId}&${BRAND_ID}=${brand_id}${sourceid}${linke_code}${appFlow}${linkResume}`
  );
  const href = `${navigate}#${token}${cust_id}${bankId}&${BRAND_ID}=${brand_id}${layout}${nav}&${REDIRECT_URI}=${redirect_uri}`;
  window.location.href = href;
}

/**
 * To redirect to personal details application
 * @param {string} case_id
 * @param {string} access_token
 * @param {string} bank_id
 * @param {string} brand_id
 * @param {string} customer_uuid
 * @param {string} offer
 * @param {string} bddpage
 * @param {string} page
 * @param {string} timestamp
 */

export function redirectToBusinessDetailsApp(
  businessDetailsUrl,
  case_id,
  access_token,
  caseSubType,
  bank_id,
  brand_id,
  businessType,
  customer_uuid,
  offerType,
  bddPage,
  page,
  show,
  navigation,
  timestamp,
  linkCode,
  applicantFlow,
  linkCodeResume
) {
  let navigate = businessDetailsUrl;
  navigate = navigate.replace(window.location.hash, '');
  const offer = offerType ? `${PRODUCT_NAME}=${offerType}` : '';
  const linke_code = linkCode ? `&${LINK_CODE_KEY}=${linkCode}` : '';
  const nav = navigation ? `&navigation=${navigation}` : '';
  const appFlow = applicantFlow ? `&${APPLICANT_FLOW}=${applicantFlow}` : '';
  const linkResume = linkCodeResume ? `&${LINK_CODE_RESUME_FLOW}=${linkCodeResume}` : '';
  const init_timestamp = timestamp ? `${INITIAL_QUESTIONS_TMSP}=${timestamp}` : '';
  const layout =
    show === BD_REVIEW
      ? `&show=${getBDDScreensByBusinessType(businessType)}`
      : `&layout=page&show=${getBDDScreensByBusinessType(businessType)}`;
  const redirect_uri = encodeURIComponent(
    `${window.location.href.replace(window.location.hash, '')}#${page.replace(
      '/',
      ''
    )}&${ACCESS_TOKEN}=${access_token || ''}&${CUSTOMER_UUID}=${customer_uuid ||
      ''}&${CASE_ID}=${case_id}&${offer}&${CASE_SUBTYPE}=${caseSubType}&${BUSINESS_TYPE}=${businessType}&${init_timestamp}&${BANK_ID}=${bank_id}&${BRAND_ID}=${brand_id}${linke_code}${appFlow}${linkResume}`
  );
  const href = `${navigate}#${ACCESS_TOKEN}=${access_token ||
    ''}&${CUSTOMER_UUID}=${customer_uuid ||
    ''}${layout}${nav}&${CASE_ID}=${case_id}${appFlow}&${CASE_SUBTYPE}=${caseSubType}&${BANK_ID}=${bank_id}&${BRAND_ID}=${brand_id}&${BUSINESS_TYPE}=${businessType}&referer=${bddPage}&${REDIRECT_URI}=${redirect_uri}`;
  window.location.href = href;
}

export const redirectToSubmissionPage = (url, caseId, token) => {
  const href = `${url}submission?caseId=${caseId}&type=current#${ACCESS_TOKEN}=${token}&scope=30`;
  window.location.href = href;
};

export const changeWindowHref = href => {
  window.location.href = href;
};
